import { Button } from '@dasa-health/components-react'
import React, { ReactNode } from 'react'
import { Modal, ModalContent, ModalFooter, ModalTitle, ModalWrapper } from './styles'

type CustomModalProps = {
    showCloseButton?: boolean
    stayConnectedButton?: boolean
    onClose?: () => void
    open?: boolean
    title?: string
    children?: ReactNode
}

export const CustomModal = ({ onClose, open, title, showCloseButton = true, children, stayConnectedButton }: CustomModalProps) => (
    <Modal data-testid="custom-modal" fullMobile={true} onClose={onClose} open={open} role="dialog">
        <ModalWrapper>
            {title && <ModalTitle>{title}</ModalTitle>}
            {children && <ModalContent>{children}</ModalContent>}
            {stayConnectedButton && (
                <ModalFooter>
                    <Button onClick={onClose} type="button" variant="tertiary" width="100%">
                        Ok, entendi
                    </Button>
                </ModalFooter>
            )}
            {showCloseButton && !stayConnectedButton && (
                <ModalFooter>
                    <Button onClick={onClose} type="button" variant="tertiary" width="100%">
                        Fechar
                    </Button>
                </ModalFooter>
            )}
        </ModalWrapper>
    </Modal>
)
